import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectUserRoles } from '@store/global/selectors';



export const useHasPermission = () => {
	
	const userRoles = useSelector(selectUserRoles);
  
	const hasPermission = useCallback((requiredRoles: undefined | null | string | string[]) => {

		if (!requiredRoles) return false;

		const requiredRolesArray = typeof requiredRoles === 'string' ? [ requiredRoles ] : requiredRoles;

		return requiredRolesArray.some((role) => userRoles.includes(role));
		
	},[ userRoles ]);
  
	return hasPermission;
};